import { useState } from "react";
import "./index.css";

const SERVER_IP = "play.despawn.io";

const features = [
  {
    icon: "🌀",
    title: "Memories & Teleporters",
    description: "Teleport to your discoveries. Every player gets personal waypoints to revisit favorite spots instantly."
  },
  {
    icon: "🎁",
    title: "Starter Kit",
    description: "Hit the ground running with a weapon and food the moment you join. No slow start here."
  },
  {
    icon: "👥",
    title: "Teams",
    description: "Team up with friends. Share bases, pool resources, and conquer the world together."
  },
  {
    icon: "🏠",
    title: "Set Homes",
    description: "Set a home across the map. Return instantly from anywhere with a simple command."
  },
  {
    icon: "🛡️",
    title: "Land Protection",
    description: "Claim and protect your builds. No griefing, no stress—your creations stay safe."
  }
];

export default function App() {
  const [copied, setCopied] = useState(false);

  const reportCopyConversion = () => {
    if (typeof window !== "undefined" && typeof window.gtag_report_conversion === "function") {
      window.gtag_report_conversion();
    }
  };

  const copyIP = async () => {
    reportCopyConversion();
    try {
      await navigator.clipboard.writeText(SERVER_IP);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      // Fallback for older browsers
      const textArea = document.createElement("textarea");
      textArea.value = SERVER_IP;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div className="page">
      {/* Hero Section */}
      <header className="hero">
        <img src="/logo.svg" alt="Despawn" className="logo" />
        <p className="eyebrow">Hytale Survival Server</p>
        <h1>Your Adventure Starts Here</h1>
        
        <div className="ip-container">
          <div className="server-ip">{SERVER_IP}</div>
          <button 
            className={`copy-button ${copied ? "copied" : ""}`}
            onClick={copyIP}
          >
            {copied ? (
              <>
                <span>✓</span> Copied!
              </>
            ) : (
              <>
                <span>📋</span> Copy Server IP
              </>
            )}
          </button>
        </div>
        
        <p className="tagline">
          Explore, build, and team up in a world packed with custom features that respect your time.
        </p>
      </header>

      {/* Features Section */}
      <section className="features-section">
        <h2>Why Players Choose Despawn</h2>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div className="feature-card" key={index}>
              <span className="feature-icon">{feature.icon}</span>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Footer CTA */}
      <footer className="footer-cta">
        <h2>Ready to Join?</h2>
        <div className="footer-ip">{SERVER_IP}</div>
        <p className="footer-message">See you in-game!</p>
      </footer>
    </div>
  );
}
